import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, ChatAvatar } from './index';
import { Theme } from '../../utils/theme';

interface MentorRecommendationProps {
  recommendationText: string;
  style?: any;
}

const MentorRecommendation: React.FC<MentorRecommendationProps> = ({ 
  recommendationText, 
  style 
}) => {
  if (!recommendationText) return null;

  return (
    <View style={[styles.container, style]}>
      <ChatAvatar type="mentor" size="medium" />
      <View style={styles.bubbleContainer}>
        <View style={styles.bubble}>
          <Text variant="body1" style={styles.recommendationText}>
            {recommendationText}
          </Text>
        </View>
        <View style={styles.bubbleTail} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: Theme.spacing.md,
    paddingHorizontal: Theme.spacing.lg,
    paddingVertical: Theme.spacing.lg,
  },
  bubbleContainer: {
    flex: 1,
    position: 'relative',
  },
  bubble: {
    backgroundColor: Theme.colors.surface,
    borderRadius: Theme.borderRadius.lg,
    padding: Theme.spacing.lg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 8,
    elevation: 3,
    borderWidth: 0.5,
    borderColor: 'rgba(1, 160, 134, 0.15)',
  },
  bubbleTail: {
    position: 'absolute',
    left: -6,
    top: 16,
    width: 12,
    height: 12,
    backgroundColor: Theme.colors.surface,
    borderLeftWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: 'rgba(1, 160, 134, 0.15)',
    transform: [{ rotate: '45deg' }],
  },
  recommendationText: {
    lineHeight: 22,
    color: Theme.colors.textPrimary,
  },
});

export default MentorRecommendation; 